"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _intl = _interopRequireDefault(require("./intl"));

var _intlLoaders = _interopRequireDefault(require("./intlLoaders"));

var _translationsLoaders = _interopRequireDefault(require("./translationsLoaders"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* eslint-disable */


var hasIntl;

try {
  hasIntl = typeof _intl.default !== 'undefined' && _intl.default.DateTimeFormat !== 'undefined';
} catch (error) {
  hasIntl = false;
}

var permitParams = function permitParams(callback) {
  if (typeof callback !== 'function') {
    throw new Error('Second argument must be function');
  }
};

var _default = function _default(locale, callback, scope) {
  permitParams(callback);

  if (!hasIntl) {
    (0, _intlLoaders.default)(locale);
    (0, _translationsLoaders.default)(locale, callback, scope);
  } else {
    (0, _translationsLoaders.default)(locale, callback, scope);
  }
};

exports.default = _default;